<template>
  <header class="w-full bg-white shadow-sm sticky top-0 z-50">
    <div
      class="max-w-7xl mx-auto flex items-center justify-between py-3 px-4 md:px-8 relative"
    >
      <!-- Лівий блок -->
      <div class="flex items-center gap-3">
        <button
          class="md:hidden flex items-center"
          aria-label="Відкрити меню"
          @click="mobileOpen = !mobileOpen"
        >
          <Menu :size="28" class="text-gray-800" />
        </button>

        <NuxtLink
          v-if="isAdmin"
          to="/admin"
          aria-label="Адмін-панель"
          class="group flex items-center"
          title="Адмінка"
        >
          <LayoutDashboard
            :size="24"
            class="transition-colors group-hover:text-pink-200 text-gray-800"
          />
        </NuxtLink>

        <MainNav />
      </div>

      <!-- Центр -->
      <NuxtLink
        to="/"
        class="font-bold text-lg md:text-2xl tracking-tight select-none absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
        style="pointer-events: auto"
      >
        Mulberry’SS
      </NuxtLink>

      <!-- Правий блок -->
      <div class="flex items-center gap-4 justify-end flex-1">
        <a
          href="https://www.instagram.com/mulberry_silk_studio/"
          target="_blank"
          rel="noopener"
          aria-label="Instagram"
          class="group hidden md:inline-block"
        >
          <Instagram
            :size="24"
            class="transition-colors group-hover:text-pink-200 text-gray-800"
          />
        </a>

        <!-- Бажане -->
        <NuxtLink
          to="/wishlist"
          aria-label="Бажане"
          class="group relative pt-1"
        >
          <!-- outline -->
          <Heart
            :size="22"
            class="transition-colors group-hover:text-pink-200 text-gray-800"
          />
          <!-- Лічильник. ClientOnly обов'язковий: обидва стори
               наповнюються з localStorage ПЕРЕД гідрацією, тож сервер
               малює шапку без бейджів, а перший клієнтський рендер — з
               ними. Це давало «Hydration completed but contains
               mismatches» на КОЖНІЙ сторінці сайту в будь-кого з
               непорожнім кошиком чи бажаним. -->
          <ClientOnly>
            <span
              v-if="wlCount"
              class="absolute -top-1 -right-1 text-[10px] leading-none px-1.5 py-0.5 bg-pink-200 text-black rounded-full"
            >
              {{ wlCount }}
            </span>
          </ClientOnly>
        </NuxtLink>

        <!-- Кошик -->
        <NuxtLink to="/cart" aria-label="Кошик" class="group relative">
          <ShoppingCart
            :size="24"
            class="transition-colors group-hover:text-pink-200 text-gray-800"
          />
          <ClientOnly>
            <span
              v-if="cart.count"
              class="absolute -top-1 -right-1 text-[10px] leading-none px-1.5 py-0.5 bg-pink-200 text-black rounded-full"
            >
              {{ cart.count }}
            </span>
          </ClientOnly>
        </NuxtLink>

        <NuxtLink to="/profile" aria-label="Кабінет" class="group">
          <User
            :size="24"
            class="transition-colors group-hover:text-pink-200 text-gray-800"
          />
        </NuxtLink>
      </div>
    </div>

    <MobileMenu :open="mobileOpen" @close="mobileOpen = false" />
  </header>
</template>

<script setup>
import { ref, computed, onMounted, watch } from "vue";
import { useCartStore } from "~/stores/cart";
import { useAuthStore } from "~/stores/auth";
import { useWishlistStore } from "~/stores/wishlist";
import {
  ShoppingCart,
  User,
  Instagram,
  Menu,
  LayoutDashboard,
  Heart,
} from "lucide-vue-next";
import MainNav from "./MainNav.vue";
import MobileMenu from "./MobileMenu.vue";

const cart = useCartStore();
const auth = useAuthStore();
const wl = useWishlistStore();

const wlCount = computed(() => wl.count);
const isAdmin = computed(() => Boolean(auth.isAdmin));
const mobileOpen = ref(false);

onMounted(() => {
  wl.init();
});
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition:
    max-height 0.3s cubic-bezier(0.4, 0, 0.3, 1),
    opacity 0.3s;
}
.slide-enter-from,
.slide-leave-to {
  max-height: 0;
  opacity: 0;
}
.slide-enter-to,
.slide-leave-from {
  max-height: calc(100vh - 50px);
  opacity: 1;
}
</style>
